import React, {useState, useEffect, useContext } from 'react';
import axios from '../Common/axios.js';
import {Button, Input, Modal, Select, Table, DatePicker, Typography, Spin} from "antd";
import CodeSelect from '../Common/CodeSelect.js';
import {getGridTableHeight, getPopupSizeOption, dateFormatter} from '../Common/util.js';
import {getFindAnalysisList, postReportAll} from '../Common/api.js';
import {excelDownload} from '../Common/function.js';
import AppContext from '../../components/AppContext.js';
import Cookies from 'js-cookie';
import TopMenu from '../Common/TopMenu.js';
import {getCodeName} from '../Common/CodeSelect.js';
import DownloadUrl from '../../components/DownloadUrl.js';
import {DownloadMd} from '../../components/DownloadPdf.js';

const {Option} = Select;
const { RangePicker } = DatePicker;

/** -------------------------------------------------------------------------- **/
const AnalysisListBox = () => {
    const myContext = useContext(AppContext);
    //console.log(myContext);

    // 쿠키에서 인증 토큰 값 가져오기
    const authToken = Cookies.get('access_token');
    // 인증 토큰 값이 존재하면 로그인된 상태로 처리
    const authenticated = authToken?true:false;

    // 변수 선언
    const [companyCode, setCompanyCode] = useState(myContext.companyCode);
    const [companyName, setCompanyName] = useState(myContext.companyName);
    const [assetType, setAssetType] = useState(myContext.assetType);
    const [assetTypeName, setAssetTypeName] = useState(myContext.assetTypeName);
    const [reportName, setReportName] = useState('');
    const [startYmd, setStartYmd] = useState('');
    const [endYmd, setEndYmd] = useState('');

    const [dataSource, setDataSource] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [isDataChange, setIsDataChange] = useState(false);
    const [isOpenInfo, setIsOpenInfo] = useState(false);

    const [isReportId, setIsReportId] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [spinflag, setSpinflag] = useState(false);    
    const loadDefaultMessage = "Loading...";
    const [loadMessage, setLoadMessage] = useState(loadDefaultMessage);

    const rowSelection = {
      selectedRowKeys,
      onChange: (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
      },
    };

    /** -------------------------------------------------------------------------- **/
    // 회사코드 변경
    const onChangeCompanyCode = (value, option) => {
        setCompanyCode(value);
        setCompanyName(option.children[2]);
        myContext.setCompanyCode(value);
        myContext.setCompanyName(option.children[2]);
    };

    // 자산유형 변경
    const onChangeAssetType = (value, option) => {
        setAssetType(value);
        setAssetTypeName(option.children[2]);
        myContext.setAssetType(value);
        myContext.setAssetTypeName(option.children[2]);
    };

    // 최초분석일자 변경
    const onChangeDateRange = (values, formatString) => {
        //console.log(formatString);
        if(formatString != null) {
            if( formatString.length >=1) {
                setStartYmd(formatString[0].replace(/[-]/g,''));
            }
            if( formatString.length >= 2) {
                setEndYmd(formatString[1].replace(/[-]/g,''));
            }
        }
    };

    // 검색 클릭 시
    const onClickSearchHandler = () => {
        // 회사 필수조건 체크
        if (companyCode == '') {
            Modal.info({title: "회사는 필수 조회조건입니다."});
            return;
        }

        // 취약점분석 조회
        findAnalysisList();

    };

    // 취약점분석 조회 API
    const findAnalysisList = () => {
        setIsLoading(true);
        setIsDataChange(false);
        axios.get(getFindAnalysisList(companyCode,assetType,reportName,startYmd,endYmd))
            .then((response) => {

                setIsLoading(false);

                if(response.data.totalCount == 0) {
                    Modal.info({title: "No Data.", okText:"Close"});
                }

                const newData = response.data.filter(item => item.created_ymd != null && item.created_ymd != '');
                setDataSource(newData);
            })
            .catch((error) => {
                console.log("AnalysisListBox --- 116 error");
                console.dir(error);
                setIsLoading(false);
            });
    };

    // 통합보고서 생성
    const pdfDownLoadReport = (event) =>{
        
        // 회사 필수조건 체크
        if (companyCode == '') {
            Modal.info({title: "회사는 필수 조회조건입니다."});
            return;
        }

        if (selectedRowKeys.length < 1){
            Modal.info({title: "보고서 생성할 대상을 선택하세요."});
            return;
        }

        const hasInvalid = members.some(member => getMessageColor(member) === 'red');

        if(hasInvalid) {
            Modal.info({ title: "보고서 입력 정보를 확인하세요. (참고내용 확인)" });
            return; // 이후 처리 중단
        }


        setSpinflag(true);
        setLoadMessage("잠시만 기다려 주세요. 보고서 작성중 입니다.");

        const reportIds = selectedRowKeys.join(','); 
        const titleName = "통합 보고서 생성";
        const buttonType = event.currentTarget.textContent;
        const membersReport = members.map(({ id, ...rest }) => rest);
        console.log("membersReport : ", membersReport);

        if (buttonType === 'Markdown') {
            axios.get(getPdfDownload("asset_md", reportId)).then((response) => {
                DownloadMd(response.data, reportId, reportName);
                setSpinflag(false);
            }).catch((error) => {
                Modal.error({title:titleName,content:"Markdown파일 다운로드 중에 에러가 발생하였습니다.", okText:"Close"});
                setSpinflag(false);
            });  
        }else{
            axios.post(postReportAll(), {
                reportIds: reportIds,
                reportType: "consolidated",
                consultant: membersReport
            }).then((response) => {
                console.dir(response);
                if(response.data.consolidated.data.status_url){
                    console.log("response.data.status_url : " + response.data.consolidated.data.status_url);
                    DownloadUrl(response.data.consolidated.data.status_url,
                        () => { 
                            setSpinflag(false); // onSuccess
                            setLoadMessage(loadDefaultMessage);
                        },
                        (errorMessage) => {
                            Modal.info({ title:titleName, content:errorMessage, okText: "Close" });
                            setSpinflag(false);
                            setLoadMessage(loadDefaultMessage);
                        }
                    );
                }else{
                    Modal.info({ title:titleName, content:"다운로드 중에 에러가 발생하였습니다.", okText: "Close" });
                    setSpinflag(false);
                    setLoadMessage(loadDefaultMessage);
                }
            }).catch((error) => {
                Modal.error({ title:titleName, content:error.message, okText: "Close" });
                setSpinflag(false);
                setLoadMessage(loadDefaultMessage);
            });   
        }  
       
        // axios.get(getPdfDownloadAsset("asset", reportId, assetCd), { responseType: 'blob' }).then((response) => {
        //     DownloadPdf(response.data, reportId, assetCd+"_상세진단")
        // })
        // .catch((error) => {
        //     console.dir(error);
        //     alert("다운로드 중에 에러가 발생하였습니다.");
        // })
        // .finally( () =>{
        //     setSpinflag(false);
        // });        
    }
    
    // 화면로딩시 자동조회
    useEffect(() => {
        
        window.onHandleDataChange = () => {
            setIsDataChange(true);
        };

        if (companyCode != '') {
            findAnalysisList();
        }
    }, []);

    // 정보 변경시 재조회
    useEffect(() => {
        // 취약점분석 조회
        if(isDataChange && companyCode != '') {
            findAnalysisList();
        }
    }, [isDataChange]);

    /** -------------------------------------------------------------------------- **/
    function onClickDetailHandler(value) {

        var _width = '1400';
        var _height = '900';
        const option = getPopupSizeOption(_width, _height);

        if (value.columnType == 'info') {
            const url = '#/analysis/info/'+value.report_id;
            const target = 'analysisInfo';
            //window.open(url, target, option);
            setIsOpenInfo(true);
            setIsReportId(value.report_id);

        } else if (value.columnType == 'created_result' || value.columnType == 'updated_result') {
            
            const resultType = value.columnType=='created_result'?'C':'U';
            const url = '#/analysis/resultpop/'+value.report_id+'/'+resultType;
            const target = 'analysisResult';
            const option_fix = getPopupSizeOption('1600', '1100', 'fix');
            window.open(url, target, option_fix);

        } else if (value.columnType == 'vulnerablity' || value.columnType == 'riskReport' || value.columnType == 'riskManagement' || value.columnType == 'implement') {
            const url = '#/report/'+value.columnType+'/'+value.report_id+(value.companyCode ? '?cd='+value.companyCode: '');
            const target = value.columnType;
            window.open(url, target, option);

        } else if (value.columnType == 'assetReport') {
            // const url = '#/report/'+value.columnType+'/'+value.report_id+'/'+value.asset_cd+'/'+value.com_cd+'/'+value.asset_type;
            // 상세진단결과 팝업창에 파라미터로 전달되는 경로패스 수정 
            // App.js 에서 {AssetReport}값이 있는 라우터 경로도 수정해줘야 한다. 
            const url = '#/report/'+value.columnType+'/'+value.report_id;
            const target = value.columnType;
            const option_fix = getPopupSizeOption('1500', '900', 'fix');
            window.open(url, target, option_fix);

        } else if (value.columnType == 'implementResult') {
            const url = '#/report/'+value.columnType+'/'+value.report_id;
            const target = value.columnType;
            const option_fix = getPopupSizeOption('1500', '900', 'fix');
            window.open(url, target, option_fix);

        } 

    };

    // 취약점분석_목록
    const analysisColumnData = [
        {
            title: '자산구분',
            dataIndex: 'asset_type',
            key: 'asset_type',
            width: '100px',
            align: 'center',
            fixed: true,
            sorter: {
                compare: (a, b) => a.asset_type.localeCompare(b.asset_type),
            },
            render: (_ , rowData ) => {
                return (
                    getCodeName('asset_type', rowData.asset_type)
                );
            },
        },
        {
            title: '취약점분석ID',
            dataIndex: 'report_id',
            key: 'report_id',
            width: '120px',
            align: 'center',
            fixed: true,
            sorter: {
                compare: (a, b) => a.report_id.localeCompare(b.report_id),
            },
        },
        {
            title: '취약점분석명',
            dataIndex: 'report_nm',
            key: 'report_nm',
            width: '250px',
            align: 'center',
            fixed: true,
            ellipsis : true,
            render: (_ , rowData ) => {
                return (
                    <div style={{color:'#0030A5'}}>
                        {rowData.report_nm}
                    </div>
                );
            },
            sorter: {
                compare: (a, b) => a.report_nm.localeCompare(b.report_nm),
            },
        },
        {
            title: '확정여부',
            dataIndex: 'confirm',
            key: 'confirm',
            width: '50px',
            align: 'center',
            fixed: true,
            ellipsis : true,
            sorter: {
                compare: (a, b) => a.confirm.localeCompare(b.confirm),
            },
        },
        {
            title: '최초분석일',
            dataIndex: 'created_ymd',
            key: 'created_ymd',
            width: '70px',
            align: 'center',
            render: (_ , rowData ) => {
                return (
                    <Typography.Link onClick={() => onClickDetailHandler({columnType: 'created_result', report_id: rowData.report_id})}>
                        {rowData.created_ymd&&rowData.created_ymd!='None'?dateFormatter(rowData.created_ymd):'Upload'}
                    </Typography.Link>
                );
            },
            // className: 'sum_col'
        },
        // {
        //     title: '취약점진단',
        //     dataIndex: 'vulnerablity',
        //     key: 'vulnerablity',
        //     width: '70px',
        //     align: 'center',
        //     render: (_ , rowData ) => {
        //         return (
        //             <Typography.Link onClick={() => onClickDetailHandler({columnType: 'vulnerablity', report_id: rowData.report_id})}>
        //                 {rowData.created_ymd&&rowData.created_ymd!='None'?'Report':''}
        //             </Typography.Link>
        //         );
        //     },
        // },
        // {
        //     title: '상세진단결과',
        //     dataIndex: 'assetReport',
        //     key: 'assetReport',
        //     width: '70px',
        //     align: 'center',
        //     render: (_ , rowData ) => {
        //         return (
        //             <Typography.Link onClick={() => onClickDetailHandler({columnType: 'assetReport', report_id: rowData.report_id})}>
        //                 {rowData.created_ymd&&rowData.created_ymd!='None'?'Report':''}
        //             </Typography.Link>
        //         );
        //     },
        // },
        // {
        //     title: '위험평가',
        //     dataIndex: 'riskReport',
        //     key: 'riskReport',
        //     width: '70px',
        //     align: 'center',
        //     render: (_ , rowData ) => {
        //         return (
        //             <Typography.Link onClick={() => onClickDetailHandler({columnType: 'riskReport', report_id: rowData.report_id, companyCode: companyCode})}>
        //                 {rowData.created_ymd&&rowData.created_ymd!='None'?'Report':''}
        //             </Typography.Link>
        //         );
        //     },
        // },
        // {
        //     title: '위험관리',
        //     dataIndex: 'riskManagement',
        //     key: 'riskManagement',
        //     width: '70px',
        //     align: 'center',
        //     render: (_ , rowData ) => {
        //         return (
        //             <Typography.Link onClick={() => onClickDetailHandler({columnType: 'riskManagement', report_id: rowData.report_id})}>
        //                 {rowData.created_ymd&&rowData.created_ymd!='None'?'Report':''}
        //             </Typography.Link>
        //         );
        //     },
        // },
        {
            title: '이행점검일',
            dataIndex: 'updated_ymd',
            key: 'updated_ymd',
            width: '70px',
            align: 'center',
            render: (_ , rowData ) => {
                return (
                    rowData.updated_ymd != "" && rowData.updated_ymd != null ? (
                    <Typography.Link onClick={() => onClickDetailHandler({columnType: 'updated_result', report_id: rowData.report_id})}>
                        {rowData.updated_ymd && rowData.updated_ymd!='None'?dateFormatter(rowData.updated_ymd):'Upload' }
                         {/* rowData.created_ymd && rowData.created_ymd!='None'?'Upload':'없음'} */}
                    </Typography.Link>):"X"
                );
            },
            // className: 'sum_col'
        },
        // {
        //     title: '이행진단',
        //     dataIndex: 'implement',
        //     key: 'implement',
        //     width: '70px',
        //     align: 'center',
        //     render: (_ , rowData ) => {
        //         return (
        //             <Typography.Link onClick={() => onClickDetailHandler({columnType: 'implement', report_id: rowData.report_id})}>
        //                 { rowData.updated_ymd && rowData.updated_ymd!='None' && (rowData.created_ymd <= rowData.updated_ymd) ?'Report':''}
        //             </Typography.Link>
        //         );
        //     },
        // },
        // {
        //     title: '이행결과',
        //     dataIndex: 'implementResult',
        //     key: 'implementResult',
        //     width: '70px',
        //     align: 'center',
        //     render: (_ , rowData ) => {
        //         return (
        //             <Typography.Link onClick={() => onClickDetailHandler({columnType: 'implementResult', report_id: rowData.report_id})}>
        //                 { rowData.updated_ymd && rowData.updated_ymd!='None' && (rowData.created_ymd <= rowData.updated_ymd) ?'Report':''}
        //             </Typography.Link>
        //         );
        //     },
        // },
    ];

        // 담당자 정보를 배열로 관리
        const [members, setMembers] = useState([
            {
                id: 1,
                name: '담당자',
                email: 'manager@example.com',
                part: '보안팀'
            }
        ]);
    
        // 입력 필드 변경 핸들러
        // const onChangeInputHandler = (e, id, field) => {
        //     const value  = e.target;
        //     setMembers(prevMembers => 
        //         prevMembers.map(member => 
        //             member.id === id ? { ...member, [field]: value } : member
        //         )
        //     );
        // };
    
        // InputText 입력값 변경
        const onChangeInputHandler = (e, id, field) => {

            if (e.target.id == "reportName" && id== 'reportName'){
                setReportName(e.target.value);
            }else{
                const value  = e.target.value;
                setMembers(prevMembers => 
                    prevMembers.map(member => 
                        member.id === id ? { ...member, [field]: value } : member
                    )
                );
            }
        };        
    
        // 인원 추가 
        const onAddMember = () => {
            const newId = members.length > 0 ? Math.max(...members.map(m => m.id)) + 1 : 1;
            setMembers([...members, {
                id: newId,
                name: '',
                email: '',
                part: ''
            }]);
        };
    
        // 인원 삭제
        const onRemoveMember = (id) => {
            setMembers(prevMembers => prevMembers.filter(member => member.id !== id));
        };

        const getErrorMessage = (member) => {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (member.name.length < 1) return '담당자 이름을 입력하세요.';
            if (member.email.length < 1) return '이메일을 입력하세요.';
            if (!emailRegex.test(member.email)) return '올바른 이메일 형식이 아닙니다.';
            if (member.part.length < 2) return '담당업무를 입력하세요.(2자 이상)';
            return '정상적으로 입력되었습니다.';
        };
          
        const getMessageColor = (member) => {
            return getErrorMessage(member) === '정상적으로 입력되었습니다.' ? 'blue' : 'red';
        };        
        
    /** -------------------------------------------------------------------------- **/
    return (
        <>
        <Spin size={"large"} style={{top:"200px",left:"2%"}} tip={loadMessage} spinning={spinflag}>
            <TopMenu selectKey='compareReport' />
            <div className="section">
                <table className='search'>
                    <colgroup>
                        <col style={{width:'5%'}} />
                        <col style={{width:'18%'}} />
                        <col style={{width:'6%'}} />
                        <col style={{width:'18%'}} />
                        <col style={{width:'7%'}} />
                        <col style={{width:'18%'}} />
                        <col style={{width:'7%'}} />
                        <col style={{width:'15%'}} />
                        <col style={{width:'6%'}} />
                    </colgroup>
                    <tbody>
                    <tr>
                        <th><span className='req'>*</span>회사</th>
                        <td>
                            <CodeSelect codeType="com_cd" 
                                        id="companyCode"
                                        value={companyCode}
                                        disabled={authenticated?true:false}
                                        onChangeHandler={onChangeCompanyCode}
                            />
                        </td>
                        <th>자산구분</th>
                        <td>
                            <CodeSelect codeType="asset_type"
                                        id="assetType"
                                        value={assetType}
                                        disabled={false}
                                        onChangeHandler={onChangeAssetType}
                                        showCompanyIndicator={true}
                                        selectedCompanyCode={companyCode}
                            />
                        </td>
                        <th>최초분석일자</th>
                        <td>
                            <RangePicker id="createYmd" size="small" 
                                onChange={onChangeDateRange}
                            />
                        </td>
                        <th>취약점 분석명</th>
                        <td>
                            <Input id="reportName" size="small"
                                   allowClear
                                   value={reportName}
                                   onChange={(e) => onChangeInputHandler(e, 'reportName', '')}
                            />
                        </td>
                        <th><Button type="default" onClick={onClickSearchHandler}>조회</Button></th>
                    </tr>
                    </tbody>
                </table>
                <table className='addmember'>
                    <colgroup>
                        <col style={{width:'5%'}} />
                        <col style={{width:'18%'}} />
                        <col style={{width:'6%'}} />
                        <col style={{width:'18%'}} />
                        <col style={{width:'7%'}} />
                        <col style={{width:'18%'}} />
                        <col style={{width:'7%'}} />
                        <col style={{width:'15%'}} />
                        <col style={{width:'6%'}} />
                    </colgroup>
            <tbody>
                {members.map((member, index) => (
                    <tr key={member.id}>
                        <th>{<span className='req'>*</span>}담당자</th>
                        <td>
                            <Input 
                                size="small"
                                allowClear
                                value={member.name}
                                onChange={(e) => onChangeInputHandler(e, member.id, 'name')}
                            />
                        </td>
                        <th>{<span className='req'>*</span>}이메일</th>
                        <td>
                            <Input 
                                size="small"
                                allowClear
                                value={member.email}
                                onChange={(e) => onChangeInputHandler(e, member.id, 'email')}
                            />
                        </td>
                        <th>{<span className='req'>*</span>}담당업무</th>
                        <td>
                            <Input 
                                size="small"
                                allowClear
                                value={member.part}
                                onChange={(e) => onChangeInputHandler(e, member.id, 'part')}
                            />
                        </td>
                        <th>참고내용</th>
                        <td>
                        <span id={`errNo${member.id}`} style={{ color: getMessageColor(member) }}>
                            {getErrorMessage(member)}
                        </span>
                        </td>
                        <th>
                            {/* {index === members.length - 1 ? ( */}
                            {index === 0 ? (
                                <Button type="default" onClick={onAddMember}>인원 추가</Button>
                            ) : (
                                <Button danger onClick={() => onRemoveMember(member.id)}>삭제</Button>
                            )}
                        </th>
                    </tr>
                ))}
            </tbody>
        </table>            
                <div className="search_button">
                    <Button type="primary" onClick={pdfDownLoadReport}>통합 진단 보고서</Button>
                    <Button type="primary" onClick={pdfDownLoadReport}>통합 위험 보고서</Button>
                </div>
            </div>
            <div className="section">
                <table style={{width:'100%'}}><tbody>
                  <tr>
                    <td width="120px"><div style={{margin:'10px 10px 10px 20px'}}>총 {dataSource?.length} 개</div></td>
                    <td><div>*아래에서 통합할 보고서를 선택해 주세요.</div></td>
                    <td style={{textAlign:'right'}}>
                        {/* <Button type="default" onClick={()=> excelDownload('취약점분석 목록', dataSource)}> Excel Download</Button> */}
                    </td>
                  </tr></tbody>
                </table>
                <Table columns={analysisColumnData}
                       dataSource={dataSource}
                       rowKey="report_id"
                       scroll={{y: getGridTableHeight(290)}}
                       loading={{
                           size: "large",
                           spinning: isLoading
                         }}
                       pagination={false}
                       bordered size={"small"}
                       style={{height:getGridTableHeight(280)}}
                       showSorterTooltip={false}
                       rowSelection={{
                         type: 'checkbox',
                         columnWidth: 22,
                         ...rowSelection,
                       }}
                />
            </div>
            {/* {isOpenCreate && (<AnalysisCreate
                open={isOpenCreate}
                p_companyCode={companyCode}
                p_companyName={companyName}
                p_assetType={assetType}
                p_assetTypeName={assetTypeName}
                rowKey="report_id"
                onClose={(p_isChange) => {
                    setIsOpenCreate(false);
                    setIsDataChange(p_isChange);
                }}
            />)}
            {isOpenInfo && (<AnalysisInfo
                open={isOpenInfo}
                p_reportId={isReportId}
                rowKey="report_id"
                onClose={(p_isChange) => {
                    setIsOpenInfo(false);
                    setIsDataChange(p_isChange);
                }}
            />)}
            {isOpenResult && (<AnalysisResult
                open={isOpenResult}
                p_reportId={isReportId}
                p_resultType={isResultType}
                rowKey="report_id"
                onClose={(p_isChange) => {
                    setIsOpenResult(false);
                    setIsDataChange(p_isChange);
                }}
            />)} */}
            </Spin>
        </>
    );
}
export default AnalysisListBox;